import { Api } from '../api';
import { auth } from '../endpoints';
import type { LoginRequest, LoginResponse, RecoveryRequest, TwoFactorRequest } from './models';

export class AuthApi extends Api {
  static login = (request: LoginRequest, signal?: AbortSignal) => this.post<LoginResponse>(auth.login(), request, { signal });

  static twoFactor = (request: TwoFactorRequest, signal?: AbortSignal) => this.post<LoginResponse>(auth.twoFactor(), request, { signal });

  static logout = () => this.post(auth.logout());

  static recovery = (request: RecoveryRequest, signal?: AbortSignal) => this.post<string>(auth.recovery(), request, { signal });
}
